import { Button, Group, Stack, Text, UnstyledButton } from '@mantine/core';
import React, { useEffect, useState } from 'react';
import styles from './styles.module.css';

interface ButtonItemProps {
  active?: boolean;
  onClick: (_data: any) => void;
  icon?: React.ComponentType;
  title?: string;
  subtitle?: string;
  value?: string | number;
  type?: 'default' | 'compact';
}

const ButtonItem: React.FC<ButtonItemProps> = ({
  active = false,
  onClick,
  icon,
  title,
  subtitle,
  value,
  type = 'default'
}) => {
  const [activated, setActivated] = useState(Boolean(active));

  useEffect(() => {
    setActivated(active);

    return () => {
      setActivated(false);
    };
  }, [active]);

  const handleClick = () => {
    onClick(value);
  };

  const IconComponent = icon || (() => null);

  if (type === 'compact') {
    return (
      <Button variant={activated ? 'filled' : 'transparent'} onClick={handleClick}>
        <Text fw={600}>{title}</Text>
      </Button>
    );
  }

  return (
    <UnstyledButton
      className={`${styles['button-group-item']} ${activated ? ' ' + styles['active'] : ''}`}
      onClick={handleClick}
    >
      <Group align='flex-start' wrap='nowrap'>
        {icon ? <IconComponent /> : null}{' '}
        <Stack gap={0}>
          <Text fw={700}>{title}</Text>
          <Text fz={12}>{subtitle}</Text>
        </Stack>
      </Group>
    </UnstyledButton>
  );
};

export default ButtonItem;
